import { getRoutesDirections } from '@/data/libraries/Routes';
import { NavigateFunction, NavLink, useNavigate } from 'react-router-dom';
import { useAppSelector } from '@/ui/store/helperRedux';

import { IUserStore } from '@/domain/interfaces/IUser';

import { getCSSVariableValue } from '@/domain/utils/CssExtractVariable';
import { translate } from '@/domain/utils/translate';

import IconList from '@/ui/components/IconList';
import ColumnWraper from '@/ui/containers/Footer/Columns/ColumnWraper';


/** Componente columna footer - Usuarios */
const ColumnUsers = (): JSX.Element => {
    /** Traemos la data el usuario para mostrarla */
    const userLogued: IUserStore = useAppSelector((state) => state.userState);

    /** Hook para generar una navegación dentro de la aplicación. */
    const navigate: NavigateFunction = useNavigate();

    const buttonVariant = getCSSVariableValue('--link-button-variant-footer');

    /** Rutas URLs */
    const routesDirections = getRoutesDirections();
    return (
        <ColumnWraper title={translate("footer.user_menu_title")}>
            <NavLink to={routesDirections.TRACKING_ROUTE}
                className={`svg-primary-4`}
                onClick={(e) => {
                    e.preventDefault();
                    if (userLogued.user.isLogued) {
                        navigate(routesDirections.PURCHASES_ROUTE);
                    } else {
                        navigate(routesDirections.TRACKING_ROUTE);
                    }
                }}
            >
                <IconList
                    iconName=''
                    classMain={`${buttonVariant} py-2 `}
                    title={userLogued.user.isLogued ? translate("footer.purchases_title") : translate("footer.purchase_tracking_title")} />
            </NavLink>
        </ColumnWraper>
    )
}

export default ColumnUsers;